import { Component, OnInit, Input } from '@angular/core';
import { Document } from '../../shared/sdk';
import { DocumentService } from '../document.service';

@Component({
  selector: 'app-document-status-badge',
  templateUrl: './document-status.component.html',
  styleUrls: ['./document-status.component.css'],
})
export class DocumentStatusComponent implements OnInit {
  @Input() document: Document;

  constructor(public documentService: DocumentService) {}

  ngOnInit() {}

  isSent(document: Document) {
    return this.documentService.isSent(document);
  }
}
